
import { css } from 'lit';
export default css`
pc-accordion-baseline pc-accordion-baseline-panel:last-child{
  border-bottom:2px solid var(--purple-medium-neutral);
}
`;